var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 37.5H50M52.5 37.5H55M57.5 37.5H60M28.75 1.25H77.5V52.5H28.75M28.75 47.5H73.75",
    stroke: "url(#paint0_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 6.25H72.5V42.5H28.75",
    stroke: "url(#paint1_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 67.5C56.5114 67.5 58.75 65.2614 58.75 62.5C58.75 59.7386 56.5114 57.5 53.75 57.5C50.9886 57.5 48.75 59.7386 48.75 62.5C48.75 65.2614 50.9886 67.5 53.75 67.5Z",
    stroke: "url(#paint2_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80V76.25C45 75.29 45.3663 74.3313 46.0988 73.5988C46.8313 72.8663 47.79 72.5 48.75 72.5H58.75C59.71 72.5 60.6687 72.8663 61.4012 73.5988C62.1337 74.3313 62.5 75.29 62.5 76.25V80",
    stroke: "url(#paint3_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 67.5C41.5114 67.5 43.75 65.2614 43.75 62.5C43.75 59.7386 41.5114 57.5 38.75 57.5C35.9886 57.5 33.75 59.7386 33.75 62.5C33.75 65.2614 35.9886 67.5 38.75 67.5Z",
    stroke: "url(#paint4_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80V76.25C30 75.29 30.3662 74.3313 31.0987 73.5988C31.8312 72.8663 32.79 72.5 33.75 72.5H41.25",
    stroke: "url(#paint5_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 67.5C71.5114 67.5 73.75 65.2614 73.75 62.5C73.75 59.7386 71.5114 57.5 68.75 57.5C65.9886 57.5 63.75 59.7386 63.75 62.5C63.75 65.2614 65.9886 67.5 68.75 67.5Z",
    stroke: "url(#paint6_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 80V76.25C77.5 75.29 77.1337 74.3313 76.4012 73.5988C75.6687 72.8663 74.71 72.5 73.75 72.5H66.25",
    stroke: "url(#paint7_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.25C20.3921 16.25 23.75 12.8921 23.75 8.75C23.75 4.60786 20.3921 1.25 16.25 1.25C12.1079 1.25 8.75 4.60786 8.75 8.75C8.75 12.8921 12.1079 16.25 16.25 16.25Z",
    stroke: "url(#paint8_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 80V46.25M16.25 80V53.75M7.5 50H1.25V28.75C1.25 26.825 1.9875 24.9125 3.45 23.45C4.9125 21.9875 6.825 21.25 8.75 21.25H11.25C11.25 22.5761 11.7768 23.8479 12.7145 24.7855C13.6521 25.7232 14.9239 26.25 16.25 26.25C17.5761 26.25 18.8479 25.7232 19.7855 24.7855C20.7232 23.8479 21.25 22.5761 21.25 21.25H50V27.5H25V80M16.25 30V32.5",
    stroke: "url(#paint9_linear_247_1758)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_247_1758",
    x1: 28.7502,
    y1: 26.8754,
    x2: 77.5,
    y2: 26.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_247_1758",
    x1: 28.7502,
    y1: 24.3753,
    x2: 72.5,
    y2: 24.3753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_247_1758",
    x1: 48.75,
    y1: 62.5001,
    x2: 58.75,
    y2: 62.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_247_1758",
    x1: 45.0001,
    y1: 76.2501,
    x2: 62.5,
    y2: 76.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_247_1758",
    x1: 33.75,
    y1: 62.5001,
    x2: 43.75,
    y2: 62.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_247_1758",
    x1: 30.0001,
    y1: 76.2501,
    x2: 41.25,
    y2: 76.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_247_1758",
    x1: 63.75,
    y1: 62.5001,
    x2: 73.75,
    y2: 62.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_247_1758",
    x1: 66.2501,
    y1: 76.2501,
    x2: 77.5,
    y2: 76.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_247_1758",
    x1: 8.75007,
    y1: 8.75011,
    x2: 23.75,
    y2: 8.75011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_247_1758",
    x1: 1.25024,
    y1: 50.6254,
    x2: 50,
    y2: 50.6254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.4fb938c87994752c38661fa29eac407f.svg";
export { ForwardRef as ReactComponent };